import { useState, useEffect } from "react";
import { fetchAppSettingByKey } from "@/services/appSettingsService";
import { debugLogger } from "@/utils/debug";

const DEFAULT_WHATSAPP_NUMBER = "85255270727";

export const useWhatsAppContact = () => {
  const [whatsappNumber, setWhatsappNumber] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchWhatsAppNumber = async () => {
      try {
        debugLogger.log('🔍 Fetching WhatsApp contact number from database...');
        const value = await fetchAppSettingByKey('WHATSAPP_CONTACT_NUMBER');

        if (value) {
          debugLogger.log('✅ WhatsApp contact number found:', value);
          setWhatsappNumber(value);
        } else {
          debugLogger.log("⚠️ No WhatsApp contact number found in settings, using default");
          setWhatsappNumber(DEFAULT_WHATSAPP_NUMBER);
        }
      } catch (error) {
        debugLogger.error("❌ Error in fetchWhatsAppNumber:", error);
        setWhatsappNumber(DEFAULT_WHATSAPP_NUMBER);
      } finally {
        setIsLoading(false);
      }
    };
    fetchWhatsAppNumber();
  }, []);

  return { whatsappNumber, isLoading };
};
